function setTitle(title) {
    if(typeof Fusion === "object" && Fusion.setTitle) {
        document.title = title
        Fusion.setTitle({navi_title: title}, function() {})
    }  else {
        document.title = title
        var iframe = document.createElement('iframe')
        iframe.style.visibility = 'hidden'
        iframe.style.display = 'none'
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = 'none'
        iframe.src = "//static.didiglobal.com/global/driver/assets/images/pixel.png";
        iframe.onload = function () {
            setTimeout(function() {
                document.body.removeChild(iframe)
            }, 0)
        }
        document.body.appendChild(iframe)
    }
}

export {
    setTitle
}
